/** Deep link to the tenant's knowledge base screen. */
export const KNOWLEDGE_BASE_HREF = "?page=knowledge-base"
